import { useMemo } from "react"

import { useTheme } from "@emotion/react"
import { useParams } from "react-router-dom"

import {
    Layer,
    MapStyles,
    ROADWORK_SECTION_LAYER,
    ROADWORK_SECTION_SOURCE,
    useMapStateContext,
    useOrderingLayers,
} from "@l2r-front/l2r-map"

import { getRoadworkTechniquesLayerStyle } from "../../constants/getRoadworkConfig"

import { RoadworkSectionSource } from "../RoadworkSectionSource"

export function RoadworkSectionLayer() {

    const theme = useTheme()
    const { getCurrentMapStyle } = useMapStateContext()
    useOrderingLayers([ROADWORK_SECTION_LAYER])
    const { road } = useParams()

    const roadworksLayerConfig = useMemo(() => {
        const referentialColor = getCurrentMapStyle() === MapStyles.plan ? theme.palette.map.darkReferential
            : theme.palette.map.lightReferential

        return getRoadworkTechniquesLayerStyle(referentialColor, null, road, {}, theme)
    }, [getCurrentMapStyle, road, theme])

    return <RoadworkSectionSource id={ROADWORK_SECTION_SOURCE}>
        <Layer
            {...roadworksLayerConfig}
            id={ROADWORK_SECTION_LAYER}
            interactive={false}
        />
    </RoadworkSectionSource>
}